import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import { useAuth } from '../contexts/AuthContext';
import ObserverDayWizard from '../components/ObserverDayWizard';

const ObserverChecklist: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleBackClick = () => {
    if (user?.role === 'observer') {
      navigate('/admin/dashboard');
    } else {
      navigate('/admin/reports');
    }
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center space-x-4">
        <button
          onClick={handleBackClick}
          className="btn btn-secondary flex items-center space-x-2"
        >
          <ArrowLeftIcon className="h-5 w-5" />
          <span>{user?.role === 'observer' ? 'Back to Dashboard' : 'Back to Reports'}</span>
        </button>
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Observer Day Checklist</h1>
          <p className="mt-1 text-sm text-gray-500">
            Election day observation checklist form
          </p>
        </div>
      </div>

      {/* Observer Day Wizard */}
      <ObserverDayWizard onClose={() => navigate(user?.role === 'observer' ? '/admin/dashboard' : '/admin/reports')} />
    </div>
  );
};

export default ObserverChecklist;